import HacizController from "../../../haciz/HacizController";
import HacizInjectable from "../../../haciz/HacizInjectable";
import {HacizEvrakTypeEnum} from "../../../uyap/enum/HacizEvrakTypeEnum";
import {AbstractTaskHandler} from "./AbstractTaskHandler";
import {ITask} from "../GorevYoneticisiTypes";
import {TopluTalepGonderTaskCevap} from "./TopluHacizHazirlaTaskHandler";
import {TaskDurum} from "../../../enum/TaskDurum";
import {StatusEnum} from "../../../enum/StatusEnum";
import JSZip from "jszip";
import app from "@/main";
import {DosyaBorclu} from "../../../uyap/DosyaBorclu";
import {DosyaBorcluEgmCevap} from "../../../uyap/DosyaBorcluEgm";
import {BorcluTakbisSorgulamaCevap} from "../../../uyap/BorcluTakbisSorgulama";
import {BorcluIcraDosyasiCevap, IIcraDosyasiSonuc} from "../../../uyap/BorcluIcraDosyasi";
import {BorcluPostaCekiCevap} from "../../../uyap/BorcluPostaCeki";
import {BorcluTur, IKisiTumDVO} from "../../../uyap/CommonInterfaces";
import {BorcluSgkHacizCevap} from "../../../uyap/BorcluSgkHaciz";
import {getGonderilenTaleplerStr} from "../../../utils/talepBilgileriUtils";
import {maasHacziGonderilsinMi} from "../../../utils/maasHacziSigortaDurumu";
import {durdurucuHataMi, tebligatAdresDegeri, tebligatAdresKodu, TebligatTuruSatiri} from "../../../utils/tebligatTalepUtils";
import {guncelTebligatTurleriniGetir} from "../../../haciz/guncelTebligatTurleri";

const KESINLESME_MSG = "Borçlu hakkındaki icra takibi kesinleştirilmediği için sorgulama yapamazsınız. ";

/** UYAP: "Bu işlem 60 dakikada 1 defa yapılabilmektedir." */
const UYAP_60_DAKIKA_KODU = "PRTL_GNL_1-1";

function uyapHataMesaji(e: unknown): string {
    if (e != null && typeof e === "object") {
        const o = e as { message?: string; error?: string };
        if (typeof o.message === "string" && o.message.length > 0) return o.message;
        if (typeof o.error === "string") return o.error;
    }
    return String(e);
}

function uyapHataKodu(e: unknown): string | undefined {
    if (e != null && typeof e === "object") {
        const k = (e as { errorCode?: string }).errorCode;
        if (typeof k === "string" && k.length > 0) return k;
    }
    return undefined;
}

/**
 * Borclu, task.data icinde JSON olarak saklanip geri okundugu icin DosyaBorclu ornegi
 * olmayabiliyor; prototip metodu yoksa alan olarak duran isKurumBool/turu okunuyor.
 */
function borcluKurumMu(borclu: DosyaBorclu): boolean {
    if (typeof borclu.isKurum === "function")
        return borclu.isKurum();
    if (typeof borclu.isKurumBool === "boolean")
        return borclu.isKurumBool;
    // isKurumBool sonradan eklendi; eski gorevlerde turu string olarak da gelebiliyor.
    return Number(borclu.turu) === BorcluTur.KURUM;
}

/** birimAdi + dosyaNo, dosyaId'nin aksine kalici olan tek kimlik ikilisi. */
function icraDosyaAnahtari(satir: { birimAdi?: string, dosyaNo?: string }): string {
    return (satir.birimAdi || "").trim() + "|" + (satir.dosyaNo || "").trim();
}

/**
 * Tazeleme sorgusu UYAP kotasindan dustugu icin, talep icerigiyle ilgisi olmayan hatalarda
 * (ag/timeout/oturum/imzaci) sorgu atilmaz.
 */
const TAZELENMEYECEK_HATALAR: readonly string[] = [
    "timeout",
    "network error",
    "oturum düştü",
    "sorgu kotası kalmadı",
    "imzacı",
];

function tazelemeDenenmeli(mesaj: string): boolean {
    const kucuk = mesaj.toLowerCase();
    return !TAZELENMEYECEK_HATALAR.some(parca => kucuk.includes(parca));
}

/**
 * UYAP gecidi coktugunde de tazeleme ise yaramaz: DEV-1131 har kaydinda istek icerigi hic
 * degismeden 26 dakika boyunca ayni portal sayfasi dondu, 18 talepli istek basarili olurken
 * tek talepli istek de ayni hatayi aldi. Ne var ki bayat dosyaId ile servis kesintisi ayni
 * mesaji uretebiliyor; bu yuzden ilk denemelerde yine tazeliyoruz, kesinti art arda
 * dogrulandiktan sonra her gorev icin bosuna kota harcamayi birakiyoruz.
 *
 * Sayac modul seviyesinde: her gorev icin yeni handler ornegi olusuyor, durum orada tutulamaz.
 */
const SERVIS_HATASI_IZI = "portal giriş sayfası";
const SERVIS_HATASI_TAZELEME_SINIRI = 2;
let ardArdaServisHatasi = 0;

const ONCEKI_CALISMA = "Önceki çalışmada gönderildi. ";

/**
 * Evrak bölündüğünde UYAP her parçaya aynı dosya adını veriyor; görev zip'inde üst üste
 * yazılmasın diye uzantıdan önce evrak sırası eklenir ("2024_19430.udf" -> "2024_19430_evrak_2.udf").
 */
function siraliEvrakAdi(ad: string | undefined, sira: number): string {
    const temel = ad || "talep_evraki.udf";
    const nokta = temel.lastIndexOf(".");
    return nokta > temel.lastIndexOf("/")
        ? temel.slice(0, nokta) + "_evrak_" + sira + temel.slice(nokta)
        : temel + "_evrak_" + sira;
}

function getBorcluKesinlesmeMesaji(borclu: DosyaBorclu): string | null {
    const sorguAlanlari = [
        (borclu.egm as any)?.message,
        (borclu.takbis as any)?.message,
        (borclu.sgkhaciz as any)?.message,
        (borclu.bankaBilgileri as any)?.message,
        (borclu.postaCeki as any)?.message,
        (borclu.sgkMossip as any)?.message,
        (borclu.icraDosyaKaydi as any)?.message
    ];
    const kesinlesmeVar = sorguAlanlari.some(msg =>
        msg && msg.includes("kesinleştirilmediği için sorgulama yapamazsınız")
    );
    return kesinlesmeVar ? KESINLESME_MSG : null;
}

export interface ResponseHacizEvrakInterface {
    message: string,
    status: StatusEnum,
    imzaliBlob: Blob | null,
    imzasizBlob: Blob | null,
    adSoyad: string,
    tcKimlikNo: string,
    evrakTutari: any,
    params: string,
    gonderilenTalepler: string,
    /** Hata satırında: bu görevde UYAP'a gönderilemeyen talepler ("Talep Adı (adet)"). */
    gonderilemeyenTalepler?: string
}

export interface TopluHacizGonderTaskResponse {
    dosyaEsasNo: string,
    icraDairesi: string,
    message: string,
    evraklar: ResponseHacizEvrakInterface[],
    /**
     * UYAP'a gitmiş taleplerin anahtarları (önceki çalışmalar dahil). Yarım kalan görev yeniden
     * başlatılırken bu response yeni görevin verisine (data.oncekiGonderim) konur; böylece
     * yalnızca gönderilemeyen talepler gider.
     */
    gonderilenTalepAnahtarlari?: string[]
}

export class TopluHacizGonderTaskHandler extends AbstractTaskHandler {
    params: any[] = [];//!:HacizParamsInterface
    async handle(task: ITask): Promise<ITask> {
        let data: TopluTalepGonderTaskCevap = new TopluTalepGonderTaskCevap(task.data.dosya, task.data.params, task.data.borclu);
        data.dosya = await app.$uyap.DosyaBul().run(task);
        this.params = data.params.hacizParams;
        let response: TopluHacizGonderTaskResponse = {
            dosyaEsasNo: data.dosya.dosyaNo,
            icraDairesi: data.dosya.birimAdi,
            message: "",
            evraklar: []
        };
        // Önceki çalışmanın sonucu iki yerden gelir: görev bitmeden uygulama kapandıysa çalışırken
        // kaydedilen ilerleme (task.response), yarım kalan görev yeniden başlatıldıysa ekranın yeni
        // göreve koyduğu eski sonuç (data.oncekiGonderim). UYAP'a gitmiş talepler yeniden
        // gönderilmez; gitmiş evrakların satırları Excel sonucunda kalsın diye yeni sonuca taşınır.
        // İmzalı evrakları taşınmaz: yeniden başlatmada eski görevin zip'inde durur, uygulama
        // görev bitmeden kapandıysa zip hiç yüklenmediği için yalnızca UYAP'ta bulunur.
        const onceki: TopluHacizGonderTaskResponse | undefined =
            task.response?.gonderilenTalepAnahtarlari ? task.response : task.data.oncekiGonderim;
        const gonderilenAnahtarlar: string[] = [...(onceki?.gonderilenTalepAnahtarlari || [])];
        response.gonderilenTalepAnahtarlari = gonderilenAnahtarlar;
        const oncekiEvraklar = (onceki?.evraklar || []).filter(evrak => evrak.status == StatusEnum.success);
        oncekiEvraklar.forEach(evrak => response.evraklar.push({
            ...evrak,
            imzaliBlob: null,
            imzasizBlob: null,
            // API metnin sonundaki boşluğu kırptığı için karşılaştırma kırpılmış önekle yapılır.
            message: String(evrak.message || "").startsWith(ONCEKI_CALISMA.trim()) ? evrak.message : ONCEKI_CALISMA + (evrak.message || "")
        }));
        // Bundan sonra handle() beklenmedik bir yerde hata fırlatsa bile TaskHandler bu sonucu
        // (gönderilen talepler dahil) kaydeder.
        task.response = response;
        const borclu = data.borclu.borcluBilgileri as IKisiTumDVO;
        const hataSatiri = (mesaj: string, gonderilemeyenTalepler: string): ResponseHacizEvrakInterface => ({
            message: mesaj,
            status: StatusEnum.error,
            imzaliBlob: null,
            imzasizBlob: null,
            adSoyad: (borclu.adi ? borclu.adi : " ") + " " + (borclu.soyadi ? borclu.soyadi : " "),
            tcKimlikNo: (borclu.tcKimlikNo ? borclu.tcKimlikNo : ""),
            evrakTutari: 0,
            params: this.params.map(u => u.talepAdi).join(', '),
            gonderilenTalepler: 'Yok',
            gonderilemeyenTalepler: gonderilemeyenTalepler
        });
        let kurulanTalepler: any[] = [];
        let parcalar: HacizInjectable[] = [];
        let gonderilenParca = 0;
        // Hata parçalara bölmeden önce olduysa kurulan taleplerin hiçbiri gitmemiştir.
        const kalanTalepler = () => getGonderilenTaleplerStr(parcalar.length > 0
            ? parcalar.slice(gonderilenParca).flatMap(parca => parca.talepBilgileri)
            : kurulanTalepler);
        // Yeniden başlatılan görev yeni bir evrak göndermeden kapanırsa önceki gönderimler Excel
        // sonucunda görünsün diye taşınan satırlar baştan kaydedilir.
        if (oncekiEvraklar.length > 0)
            await this.ilerlemeyiKaydet(task, response);
        // gonder() cevapsız kalırsa (zaman aşımı, ağ) evrak UYAP'a ulaşmış olabilir.
        let gonderimSonucuBelirsiz = false;
        try {
            const kesinlesmeMsg = getBorcluKesinlesmeMesaji(data.borclu);
            if (kesinlesmeMsg) {
                throw new Error(kesinlesmeMsg);
            }
            // 89/1 ihbarnamesinin tebligat ücreti ve tür adı gönderim anında UYAP'tan alınır
            // (DEV-3519). İhbarname yoksa bu ücretsiz liste sorgusu da yapılmaz. UYAP evrakı tek
            // parça doğruladığı için yanlış 89/1 ücreti diğer haciz taleplerini de düşürür; ücret
            // doğrulanamazsa evrak hiç gönderilmez.
            const tebligatTurleri = this.ihbarname89_1GonderilecekMi(data)
                ? await guncelTebligatTurleriniGetir()
                : null;
            if (tebligatTurleri)
                await this.ihbarname89_1AdresleriniTamamla(data, gonderilenAnahtarlar);
            let hacizController = this.hacizControllerOlustur(data, tebligatTurleri, gonderilenAnahtarlar);
            kurulanTalepler = hacizController.talepBilgileri;
            // Önceki çalışmada bütün talepler gitmişse (uygulama son evraktan sonra kapanmış)
            // gönderilecek talep kalmaz; görev taşınan satırlarla başarılı biter.
            if (kurulanTalepler.length == 0 && gonderilenAnahtarlar.length == 0)
                throw new Error("Yapılan sorgulamalar sonucunda haciz talebi oluşturma şartları sağlanmamıştır");
            // UYAP tek evrakta en fazla 5 haciz talebi kabul ediyor. Hazırlama hiçbir şey göndermediği
            // için önce bütün parçalar hazırlanır: bayat dosyaId gibi bir hata, ilk evrak gitmeden
            // yakalanır ve aşağıdaki tazeleme hiçbir evrakı ikinci kez göndermez.
            parcalar = kurulanTalepler.length > 0 ? hacizController.parcala() : [];
            // Evrak bölününce ücretsiz parçalar gidip ücretli parça bakiye yüzünden kalmasın diye
            // toplam tutar ilk gönderimden önce kontrol edilir. Bölünmeyen evrakta akış eskisi gibi.
            if (parcalar.length > 1)
                await hacizController.bakiyeyiKontrolEt();
            let hazirlanan: HacizInjectable = parcalar[0];
            try {
                for (hazirlanan of parcalar)
                    await hazirlanan.hacizEvrakHazirla();
                ardArdaServisHatasi = 0;
            } catch (e) {
                const hataMesaji = uyapHataMesaji(e);
                const servisHatasi = hataMesaji.includes(SERVIS_HATASI_IZI);
                ardArdaServisHatasi = servisHatasi ? ardArdaServisHatasi + 1 : 0;

                // Tazeleme kotadan düştüğü için yalnızca hata veren parçada yabancı dosyaId varsa denenir.
                if (!this.alacakliOlduguDosyaTalebiVarMi(hazirlanan) || !tazelemeDenenmeli(hataMesaji))
                    throw e;
                if (servisHatasi && ardArdaServisHatasi > SERVIS_HATASI_TAZELEME_SINIRI)
                    throw e;
                // UYAP dosyaId'leri her cevapta yeniden sifreleniyor. Alacakli oldugu dosya talebi,
                // HacizController'daki tek "yabanci dosyaId" tasiyan talep turu; bu deger Hazirla
                // asamasinda alinip task ile birlikte kaydedildigi icin gonderim aninda bayat
                // olabiliyor. Gorevi bastan calistirmak bu degeri tazelemedigi (kullanicinin
                // sihirbazi bastan yapip borclulari elle secmesi gerektigi) icin tazeleme burada,
                // gonderim aninda yapiliyor. Sorgu kotadan dustugunden SADECE hata halinde ve
                // yalnizca dosyanin ucretsiz sorgu hakki varsa. (DEV-1131)
                await this.alacakliOlduguDosyalariTazele(data, hataMesaji);
                hacizController = this.hacizControllerOlustur(data, tebligatTurleri, gonderilenAnahtarlar);
                if (hacizController.talepBilgileri.length == 0)
                    throw e;
                kurulanTalepler = hacizController.talepBilgileri;
                parcalar = hacizController.parcala();
                for (const parca of parcalar)
                    await parca.hacizEvrakHazirla();
                ardArdaServisHatasi = 0;
            }
            //hacizController.hacizEvrakIndir();
            // Parçalar sırayla gider ve ilk hatada durulur: hata çoğunlukla oturum, bakiye ya da
            // UYAP kesintisi gibi sonraki parçayı da düşürecek bir nedendir.
            for (const parca of parcalar) {
                await parca.hacizEvrakImzala();
                gonderimSonucuBelirsiz = true;
                let evrakResult = await parca.gonder();
                gonderimSonucuBelirsiz = false;
                // gonder() UYAP hatasinda reject etmiyor, cevabi dondurup geciyor.
                // Kontrol edilmezse basarisiz gonderim "BITTI_BASARILI" olarak isaretleniyor.
                if (evrakResult.result === "error")
                    throw new Error(evrakResult.message);
                gonderilenAnahtarlar.push(...parca.talepAnahtarlari);
                gonderilenParca++;
                // Borçlunun birden çok evrakı varsa (bu çalışmada ya da öncekilerle birlikte) zip'te
                // sırayla adlandırılır; sıra önceki çalışmalarda gidenlerden devam eder.
                if (parcalar.length > 1 || oncekiEvraklar.length > 0) {
                    const imzali: any = parca.getHacizEvrakImzali();
                    imzali.name = siraliEvrakAdi(imzali.name, oncekiEvraklar.length + gonderilenParca);
                }
                response.evraklar.push({
                    message: evrakResult.message,
                    status: StatusEnum.success,
                    imzaliBlob: parca.getHacizEvrakImzali(),
                    imzasizBlob: parca.getHacizEvrakImzasiz(),
                    adSoyad: (borclu.adi ? borclu.adi : " ") + " " + (borclu.soyadi ? borclu.soyadi : " "),
                    tcKimlikNo: (borclu.tcKimlikNo ? borclu.tcKimlikNo : ""),
                    evrakTutari: parca.evrakTutar.toFixed(2),
                    params: this.params.map(u => u.talepAdi).join(', '),
                    gonderilenTalepler: getGonderilenTaleplerStr(parca.talepBilgileri)
                })
                // Tek evraklı görevde akış eskisi gibi; çok evraklıda son evrak da kaydedilir, çünkü
                // zip yüklemesi ve son kayıt bitmeden uygulama kapanabilir.
                if (parcalar.length > 1 || oncekiEvraklar.length > 0)
                    await this.ilerlemeyiKaydet(task, response, gonderilenParca < parcalar.length ? hataSatiri(
                        "Görev tamamlanmadan durdu; " + gonderilenParca + "/" + parcalar.length + " evrak gönderildi. " +
                        "Gönderilemeyen talepler: " + kalanTalepler() + ". Görev yeniden başlatılırsa yalnızca bunlar gönderilir. " +
                        "Uygulama gönderim sırasında kapandıysa sıradaki evrak UYAP'a ulaşmış olabilir; önce dosyayı UYAP'tan kontrol ediniz.",
                        kalanTalepler()) : undefined);
            }
        } catch (e) {
            console.error("Toplu Haciz Gonder ERROR",e);
            const gonderilemeyenTalepler = kalanTalepler();
            let mesaj = (e as Error).message;
            // UYAP'ın hata koduyla reddettiği evrak gitmemiştir; cevapsız kalan gitmiş olabilir.
            if (gonderimSonucuBelirsiz && !uyapHataKodu(e) && !durdurucuHataMi(e))
                mesaj += " | Bu evrak UYAP'a ulaşmış olabilir; görevi yeniden başlatmadan önce dosyayı UYAP'tan kontrol ediniz.";
            if (gonderilenParca > 0)
                mesaj = gonderilenParca + "/" + parcalar.length + " evrak gönderildi. Gönderilemeyen talepler: " +
                    gonderilemeyenTalepler + ". Görev yeniden başlatılırsa yalnızca bunlar gönderilir. Hata: " + mesaj;
            response.evraklar.push(hataSatiri(mesaj, gonderilemeyenTalepler));
        }

        let evrakVarMi = false;
        let zipHatasi = "";
        let zip = new JSZip();
        for (let evrak of response.evraklar) {
            if (evrak.imzaliBlob) {
                // @ts-ignore
                zip.file((evrak.adSoyad + "/" + evrak.imzaliBlob.name), evrak.imzaliBlob);
                evrakVarMi = true;
            }
        }

        if (evrakVarMi) {
            let zipBlob = await zip.generateAsync({type: "blob"});
            let formData = new FormData();
            // @ts-ignore
            let name = task.birim_adi + ' ' + task.dosya_esas_no.replaceAll('/', '_') + ' Toplu Haciz Talepleri.zip';
            formData.append('name', name);
            formData.append('file', zipBlob, name);
            formData.append('task_id', (task.id as string));
            try {
                await app.$http.post('/api/v1/task/file', formData);
            } catch (e) {
                // Evraklar UYAP'a gitti. Burada hata fırlatılırsa görev sonucu (gönderilen talepler
                // dahil) kaydedilmeden "hatalı" olur ve yeniden başlatıldığında hepsi ikinci kez gider.
                console.error("Toplu Haciz Gonder: imzalı evrak zip'i yüklenemedi", e);
                zipHatasi = "İmzalı evrakların zip dosyası kaydedilemedi: " + uyapHataMesaji(e);
            }
        }

        let errorExists = response.evraklar.filter(evrak => evrak.status == StatusEnum.error);
        task.status = TaskDurum.BITTI_BASARILI;
        if (errorExists.length == response.evraklar.length)
            task.status = TaskDurum.BITTI_HATALI;
        else if (errorExists.length > 0)
            task.status = TaskDurum.BITTI_EKSIK;
        task.response = response;
        task.description = errorExists.map(x => x.message).concat(zipHatasi ? [zipHatasi] : []).join(" , ");
        if (response.message != "")
            task.description = response.message;
        return task;
    }

    /**
     * Gönderilen her evraktan sonra o ana kadarki sonucu görev kaydına yazar; kalan talep varsa
     * son satır onları gösterir. Uygulama görev bitmeden kapanırsa ya da çökerse görev
     * yeniden çalıştığında (ya da yeniden başlatıldığında) UYAP'a gitmiş talepler buradan okunur
     * ve ikinci kez gönderilmez. Yalnızca response yazılır: status gönderilmediği için API'de paket
     * durumu etkilenmez. Kayıt başarısız olursa gönderim sürer.
     */
    private async ilerlemeyiKaydet(task: ITask, response: TopluHacizGonderTaskResponse, kalanSatiri?: ResponseHacizEvrakInterface): Promise<void> {
        try {
            await app.$http.put('/api/v1/task/' + task.id, {
                response: {
                    ...response,
                    gonderilenTalepAnahtarlari: [...(response.gonderilenTalepAnahtarlari || [])],
                    // Blob JSON'a {} olarak gider ve API'den [] (doğru sayılan bir değer) olarak döner.
                    evraklar: response.evraklar.concat(kalanSatiri ? [kalanSatiri] : [])
                        .map(evrak => ({...evrak, imzaliBlob: null, imzasizBlob: null}))
                }
            });
        } catch (e) {
            console.warn("Toplu Haciz Gonder: ilerleme kaydedilemedi", uyapHataMesaji(e));
        }
    }

    /**
     * Secilen talep turlerinden talepBilgileri listesini kurar.
     * Ayri metod: alacakli oldugu dosya bilgileri tazelendikten sonra liste bastan kurulmali.
     */
    private ihbarname89_1GonderilecekMi(data: TopluTalepGonderTaskCevap): boolean {
        return this.params.some(param => param.className == HacizEvrakTypeEnum.IHBARNAME_89_1) &&
            data.borclu.haciz.ihbarname89_1Selected !== false &&
            (data.borclu.haciz.ihbarname89_1Params || []).length > 0;
    }

    /**
     * Adresi boş kalmış 89/1 taleplerinin adresini gönderimden önce UYAP'tan sorgular (DEV-3687).
     *
     * Talep düzenleme ekranında adres türü varsayılan olarak E-Tebligat geliyor ama adres yalnızca
     * kullanıcı "Sorgula"ya basınca doluyordu; boş adresli talep UYAP'ta genel hatayla düşüyor ve
     * aynı evraktaki diğer haciz taleplerini de düşürüyordu. Sorgu ekrandakiyle aynı: borçlunun
     * kisiKurumId'si ve 3. şahsın kayitId'si. Adres yine bulunamazsa ihbarname89_1Ekle anlaşılır
     * bir hatayla durur. Dolu adreslere dokunulmaz.
     */
    private async ihbarname89_1AdresleriniTamamla(data: TopluTalepGonderTaskCevap, gonderilmis: string[]): Promise<void> {
        const paramlar = data.borclu.haciz.ihbarname89_1Params || [];
        for (let sira = 0; sira < paramlar.length; sira++) {
            const p = paramlar[sira];
            if (gonderilmis.includes(HacizEvrakTypeEnum.IHBARNAME_89_1 + ":" + sira))
                continue;
            if (p.adres && String(p.adres).trim() !== "")
                continue;
            const adresKodu = tebligatAdresKodu(p.adresTuru);
            if (adresKodu === null)
                continue;
            try {
                const cevap = await app.$uyap.GetIcraTebligatTalebiAdresSorgula().run({
                    dosyaId: data.dosya.dosyaId,
                    kisiKurumId: data.borclu.kisiKurumId,
                    kayitId: p.kisiKurumId,
                    adresTuru: adresKodu
                });
                const adres = tebligatAdresDegeri(cevap, adresKodu);
                if (adres !== null)
                    p.adres = adres;
            } catch (e) {
                if (durdurucuHataMi(e))
                    throw e;
                console.warn("89/1 adres sorgusu başarısız:", p.kurumAdi, adresKodu, uyapHataMesaji(e));
            }
        }
    }

    private hacizControllerOlustur(data: TopluTalepGonderTaskCevap, tebligatTurleri: TebligatTuruSatiri[] | null, gonderilmis: string[]): HacizController {
        let hacizController = new HacizController(data.borclu, data.dosya);
        hacizController.tebligatTurleri = tebligatTurleri;
        // Anahtar, talebin görev verisindeki yeridir (tür + listedeki sırası); görev verisi
        // çalışmalar arasında değişmediği için aynı talep her kurulumda aynı anahtarı alır.
        // Önceki çalışmada UYAP'a gitmiş talep yeniden kurulmaz.
        const ekle = (anahtar: string, talebiEkle: () => void) => {
            if (gonderilmis.includes(anahtar))
                return;
            talebiEkle();
            hacizController.talepAnahtarlari.push(anahtar);
        };
        for (const param of this.params) {
            switch (param.className) {
                case HacizEvrakTypeEnum.ARAC_HACZI: {
                    let egm = data.borclu.egm as DosyaBorcluEgmCevap;
                    console.log("HacizEvrakTypeEnum.ARAC_HACZI egm", egm);
                    if (egm.sorguSonucu && egm.sorguSonucDVO && egm.sorguSonucDVO.aracBilgileri.aracList) {
                        egm.sorguSonucDVO.aracBilgileri.aracList.forEach((arac, sira) => {
                            if (arac.selected == true)
                                ekle(param.className + ":" + sira, () => hacizController.aracHacizEkle(arac.hacizSerhi, arac.plakaSifreli, arac.plaka))
                        })
                    }
                    break;
                }
                case HacizEvrakTypeEnum.TASINMAZ_HACZI: {
                    let takbis = data.borclu.takbis as BorcluTakbisSorgulamaCevap;
                    if (takbis.sorguSonucu && Array.isArray(takbis.sorguSonucDVO)) {
                        takbis.sorguSonucDVO.forEach((tasinmaz, sira) => {
                            if (tasinmaz.selected == true)
                                ekle(param.className + ":" + sira, () => hacizController.tasinmazHacizEkle(tasinmaz));
                        })
                    }
                    break;
                }
                case HacizEvrakTypeEnum.ALACAKLI_OLDUGU_DOSYA: {
                    let icraDosyaKaydi = data.borclu.icraDosyaKaydi as BorcluIcraDosyasiCevap;
                    if (icraDosyaKaydi.sorguSonucu && icraDosyaKaydi.sorguSonucDVO) {
                        // Diger talep turlerinin aksine burada secim kontrolu yoktu; kullanicinin
                        // listeden kaldirdigi dosyalar da gonderiliyordu. UYAP evragi tek parca
                        // dogruladigi icin listedeki tek bir gecersiz satir (orn. Talimat Dosyasi)
                        // evragin tamamini dusuruyor. (DEV-1131)
                        icraDosyaKaydi.sorguSonucDVO.forEach((kayitliDosya, sira) => {
                            if (kayitliDosya.selected !== false)
                                ekle(param.className + ":" + sira, () => hacizController.alacakliOlduguDosyaEkle(kayitliDosya));
                        });
                    }
                    break;
                }
                case HacizEvrakTypeEnum.BANKA_HACZI: {
                    if (data.borclu.haciz.bankaHacziSelected !== false &&
                        data.borclu.haciz.bankaHesapHacziParams.bankaList.length > 0 &&
                        data.borclu.haciz.bankaHesapHacziParams.hesapList.length > 0) {
                        ekle(param.className, () => hacizController.bankaHacizEkle());
                    }
                    break;
                }
                case HacizEvrakTypeEnum.POSTA_CEKI_HACZI: {
                    let postaCeki = data.borclu.postaCeki as BorcluPostaCekiCevap;
                    if (data.borclu.haciz.postaCekiHacziSelected !== false && postaCeki.sorguSonucu)
                        ekle(param.className, () => hacizController.postaCekiHacziEkle());
                    break;
                }
                case HacizEvrakTypeEnum.SGK_MOSSIP_HACZI: {
                    let sgkMossip = data.borclu.sgkMossip as BorcluSgkHacizCevap;
                    if (sgkMossip.sorguSonucu && sgkMossip.sorguSonucDVO) {
                        sgkMossip.sorguSonucDVO.forEach((mossip, sira) => {
                            if (mossip.selected == true)
                                ekle(param.className + ":" + sira, () => hacizController.sgkMossipHacizEkle(mossip));
                        })
                    }
                    break;
                }
                case HacizEvrakTypeEnum.TASINIR_HACZI: {
                    if (data.borclu.haciz.tasinirHacziSelected !== false)
                        ekle(param.className, () => hacizController.tasinirHacizEkle(data.borclu.haciz.tasinirHacziParams.aciklama));
                    break;
                }
                case HacizEvrakTypeEnum.TASINIR_HACIZ_TALIMATI: {
                    if (data.borclu.haciz.tasinirHacizTalimatiSelected !== false)
                        ekle(param.className, () => hacizController.tasinirHacizTalimatiEkle(data.borclu.haciz.tasinirHacizTalimatiParams));
                    break;
                }
                case HacizEvrakTypeEnum.IHBARNAME_89_1: {
                    if (data.borclu.haciz.ihbarname89_1Selected !== false)
                        (data.borclu.haciz.ihbarname89_1Params || []).forEach((p, sira) => ekle(param.className + ":" + sira, () => hacizController.ihbarname89_1Ekle(p)));
                    break;
                }
                case HacizEvrakTypeEnum.IHBARNAME_89_2: {
                    if (data.borclu.haciz.ihbarname89_2Selected !== false)
                        (data.borclu.haciz.ihbarname89_2Params || []).forEach((p, sira) => ekle(param.className + ":" + sira, () => hacizController.ihbarname89_2Ekle(p)));
                    break;
                }
                case HacizEvrakTypeEnum.IHBARNAME_89_3: {
                    if (data.borclu.haciz.ihbarname89_3Selected !== false)
                        (data.borclu.haciz.ihbarname89_3Params || []).forEach((p, sira) => ekle(param.className + ":" + sira, () => hacizController.ihbarname89_3Ekle(p)));
                    break;
                }
                case HacizEvrakTypeEnum.MAAS_HACZI: {
                    // Kurum borclunun maasi olmadigi icin maas haczi talebi gonderilemez. Hazirlama
                    // adiminda zaten secilmiyor; bu duzeltmeden once siraya girmis gorevlerde de
                    // evraga girmesin diye burada da eleniyor.
                    if (!borcluKurumMu(data.borclu) && maasHacziGonderilsinMi(data.borclu)) {
                        ekle(param.className, () => hacizController.maasHacizEkle(data.borclu.haciz.maasHacziParams))
                    }
                    break;
                }
            }
        }
        return hacizController;
    }

    private alacakliOlduguDosyaTalebiVarMi(hacizController: HacizInjectable): boolean {
        return hacizController.talepBilgileri
            .some((talep: any) => talep.className == HacizEvrakTypeEnum.ALACAKLI_OLDUGU_DOSYA);
    }

    /**
     * Borclunun alacakli oldugu dosyalari UYAP'tan yeniden sorgulayip elimizdeki satirlarin
     * dosyaId'lerini gunceller. Eslestirme birimAdi + dosyaNo uzerinden yapilir; dosyaId
     * kalici olmadigi icin eslestirmede kullanilamaz.
     *
     * Yalnizca evrak hazirlama hata verdiginde cagrilir ve iki kapisi vardir: dosyanin
     * ucretsiz sorgu kotasi olmali (yoksa ucret kesilir) ve ayni sorgu UYAP'ta 60 dakikada
     * 1 kez yapilabilir. Ikisinden birine takilirsa kullaniciya ne yapmasi gerektigini
     * soyleyen bir mesajla cikilir.
     */
    private async alacakliOlduguDosyalariTazele(data: TopluTalepGonderTaskCevap, ilkHata: string): Promise<void> {
        const eskiSatirlar = (data.borclu.icraDosyaKaydi as BorcluIcraDosyasiCevap)?.sorguSonucDVO || [];
        if (eskiSatirlar.length == 0)
            throw new Error(ilkHata);

        // Tazeleme UYAP kotasindan dusuyor. Kota bitmisken sorgu atmak ucret kesilmesine yol
        // actigi icin, kotanin varligi DOGRULANMADAN UYAP'a gidilmiyor: bakiye okunamazsa da
        // tazeleme yapilmiyor (bakiye sorgusu da coktuyse tazeleme zaten basarisiz olurdu).
        let kalanSorgu: number;
        try {
            kalanSorgu = (await app.$uyap.SorguBakiyesi().run({dosyaId: data.dosya.dosyaId})).sorguKalanIslemSayisi;
        } catch (e) {
            throw new Error(ilkHata + " | Alacaklı olduğu dosya bilgileri yenilenecekti ancak " +
                "sorgu kotası okunamadığı için sorgu atılmadı: " + uyapHataMesaji(e));
        }
        if (kalanSorgu <= 0)
            throw new Error(ilkHata + " | Alacaklı olduğu dosya bilgilerinin yenilenmesi gerekiyor " +
                "fakat bu dosyanın ücretsiz sorgu kotası dolu. Kota yenilendikten sonra görevi tekrar çalıştırınız.");

        let taze: BorcluIcraDosyasiCevap;
        try {
            taze = await app.$uyap.BorcluIcraDosyasi().fresh().run({
                dosyaId: data.dosya.dosyaId,
                kisiKurumId: data.borclu.kisiKurumId
            });
        } catch (e) {
            const mesaj = uyapHataMesaji(e);
            if (uyapHataKodu(e) == UYAP_60_DAKIKA_KODU || mesaj.indexOf("60 dakikada 1 defa") >= 0)
                throw new Error(ilkHata + " | Alacaklı olduğu dosya bilgileri bayatlamış olabilir. " +
                    "Yenilemek için gereken UYAP sorgusu 60 dakikada 1 kez yapılabildiğinden yenileme yapılamadı; " +
                    "lütfen bir süre sonra tekrar deneyiniz.");
            throw new Error(ilkHata + " | Alacaklı olduğu dosya bilgileri yenilenemedi: " + mesaj);
        }

        if (!taze.sorguSonucu || !taze.sorguSonucDVO)
            throw new Error(ilkHata + " | Borçlunun alacaklı olduğu dosya kaydı UYAP'ta artık bulunamıyor.");

        const tazeSatirlar = new Map<string, IIcraDosyasiSonuc>();
        taze.sorguSonucDVO.forEach(satir => tazeSatirlar.set(icraDosyaAnahtari(satir), satir));

        let eslesenSayisi = 0;
        for (const satir of eskiSatirlar) {
            const yeni = tazeSatirlar.get(icraDosyaAnahtari(satir));
            if (!yeni) {
                // UYAP listesinde artik yok; gonderilirse evragin tamami duser.
                satir.selected = false;
                continue;
            }
            satir.dosyaId = yeni.dosyaId;
            satir.guncelKisiKurumId = yeni.guncelKisiKurumId;
            satir.dosyaTurKodu = yeni.dosyaTurKodu;
            satir.dosyaTurKoduAciklama = yeni.dosyaTurKoduAciklama;
            satir.dosyaDurumuAciklama = yeni.dosyaDurumuAciklama;
            eslesenSayisi++;
        }
        if (eslesenSayisi == 0)
            throw new Error(ilkHata + " | Alacaklı olduğu dosyaların hiçbiri güncel UYAP sorgusuyla eşleşmedi.");
        console.log("DEV-1131: alacaklı olduğu dosya bilgileri tazelendi, eşleşen satır:", eslesenSayisi);
    }
}